enum ContactRoutes {
  List = '/contacts',
  Edit = '/contacts/edit/:id',
  Add = '/contacts/add/:company_id',
}

export default ContactRoutes
